import React, { useEffect } from 'react';
import { Alert, Box, Container, Link, Paper, Stack, Typography } from '@mui/material';
import { LEGAL_DETAILS, isDraft, privacyPolicy, termsOfService } from './legalContent';

const DOCUMENTS = {
  privacy: { build: privacyPolicy, path: '/privacy' },
  terms: { build: termsOfService, path: '/terms' }
};

/** Public, signed-out page for the Privacy Policy or Terms of Service. */
const LegalPage = ({ document: kind, details = LEGAL_DETAILS }) => {
  const doc = DOCUMENTS[kind].build(details);
  const other = kind === 'privacy' ? termsOfService(details) : privacyPolicy(details);
  const otherPath = kind === 'privacy' ? DOCUMENTS.terms.path : DOCUMENTS.privacy.path;

  useEffect(() => {
    window.document.title = `${doc.title} | ZenRentFlow`;
  }, [doc.title]);

  return (
    <Container maxWidth="md" sx={{ py: { xs: 3, sm: 6 } }}>
      <Paper sx={{ p: { xs: 3, sm: 5 } }}>
        {isDraft(details) && (
          <Alert severity="warning" sx={{ mb: 3 }}>
            Draft for review. This document is not in effect yet.
          </Alert>
        )}
        <Typography variant="overline" color="text.secondary">
          ZenRentFlow
        </Typography>
        <Typography variant="h4" component="h1" gutterBottom>
          {doc.title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Effective {details.effectiveDate}
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          {doc.intro}
        </Typography>

        <Stack spacing={3}>
          {doc.sections.map((section) => (
            <Box component="section" key={section.heading}>
              <Typography variant="h6" component="h2" gutterBottom>
                {section.heading}
              </Typography>
              {(section.paragraphs || []).map((text) => (
                <Typography variant="body1" key={text} sx={{ mb: 1.5 }}>
                  {text}
                </Typography>
              ))}
              {section.bullets && (
                <Box component="ul" sx={{ pl: 3, my: 0 }}>
                  {section.bullets.map((text) => (
                    <Typography component="li" variant="body1" key={text} sx={{ mb: 0.75 }}>
                      {text}
                    </Typography>
                  ))}
                </Box>
              )}
            </Box>
          ))}
        </Stack>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
          See also our <Link href={otherPath}>{other.title}</Link>.
        </Typography>
      </Paper>
    </Container>
  );
};

export default LegalPage;
